import React from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { PricedAtShop } from "../PricedAtShop"
import { OIL_CHANGE } from "../../../../v1/actions/services"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"

const ServiceTile = ({ service, handleService, user, activeVehicle, cart }) => {
  const { t } = useTranslation("common")
  return (
    <>
      <div className="row-space-between">
        <div className="service-container">
          <div className="service-name">{service.name}</div>
          {service.position && (
            <>
              <div className="service-position">{service.position}</div>
              <div className="service-position">
                {service.reference_id === OIL_CHANGE &&
                service.position === activeVehicle.oil_type_name
                  ? "Manufacturer recommended"
                  : ""}
              </div>
            </>
          )}
          {!isEbayTireOrder(cart) && (
            <p
              className="link-text"
              onClick={() => {
                handleService(service, "removed")
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_selected_shop_review_page
                })
              }}
            >
              {t("remove")}
            </p>
          )}
        </div>
        {service?.price_estimate?.shop_price_estimate != null && user && user.country !== "ca" ? (
          <div className="shop-price-est">
            ${Number(service.price_estimate.shop_price_estimate).toFixed(2)}
          </div>
        ) : cart && isEbayTireOrder(cart) ? (
          <div className="shop-price-est">
            ${Number(service.price_estimate.shop_price_estimate || 0).toFixed(2)}
          </div>
        ) : (
          <div style={{ fontSize: "14px" }}>
            <PricedAtShop />
          </div>
        )}
      </div>
      <div className="spacer-10" />
    </>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}

  return {
    user: user,
    activeVehicle
  }
}

export default connect(mapStateToProps)(ServiceTile)
